(function () {
  function init() {
    try { document.documentElement.classList.remove('smt-loadding'); } catch (e) {}

    var success = document.querySelector('.co-fleet-success');
    if (success) {
      try { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    // Smooth scroll naar #offerte met header-offset + highlight-pulse
    function scrollToOfferte(e) {
      var target = document.getElementById('offerte');
      if (!target) return;
      if (e) e.preventDefault();

      // Bereken offset (probeer sticky header te compenseren)
      var stickyHeader = document.querySelector('.t4s-header-sticky--active, .t4s-sticky-active, header[class*="sticky"]');
      var headerH = stickyHeader ? stickyHeader.offsetHeight : 0;
      var rect = target.getBoundingClientRect();
      var y = rect.top + window.pageYOffset - headerH - 20;

      window.scrollTo({ top: y, behavior: 'smooth' });

      // Highlight-pulse: subtiele flash op de offerte-kaart
      target.classList.add('co-fleet-highlight');
      setTimeout(function () {
        target.classList.remove('co-fleet-highlight');
      }, 1600);

      // Focus eerste input na scroll voor betere UX
      setTimeout(function () {
        var firstInput = target.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus({ preventScroll: true });
      }, 700);
    }

    document.querySelectorAll('a[href="#offerte"]').forEach(function (a) {
      a.addEventListener('click', scrollToOfferte);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
